/**
 * Marqueurs toiture sur carte PV (dossier `public/icons/map/`, cohérent legacy).
 * @see PVRoofMap.vue
 */
export const PIN_DATA_BLUE = "/icons/map/pin-data-blue.svg"
export const PIN_DATA_GREY = "/icons/map/pin-data-grey.svg"
/** Taille affichée du pastille (divIcon Leaflet) : lisible sans être trop lourd. */
export const ROOF_MAP_MARKER_PX = 24

/**
 * Génère le HTML pour un pin avec numéro (propriété GeoJSON `customHtml` de BaseMap).
 * Contenu généré en interne uniquement (icône + indice d’affichage).
 * @param displayIndex - numéro affiché au centre (1-based recommandé)
 * @param isActive - `true` = pastille bleue, `false` = gris
 */
export function buildRoofMapMarkerCustomHtml(
    displayIndex: number,
    isActive: boolean
): string {
    const src = isActive ? PIN_DATA_BLUE : PIN_DATA_GREY
    const w = ROOF_MAP_MARKER_PX
    const d = String(Math.max(0, Math.floor(displayIndex)))
    // overflow + tailles fixes : évite qu’un `img { max-width: 100% }` global ne casse l’icône / l’ancrage Leaflet.
    return `<div class="pv-roof-map__marker" style="box-sizing:border-box;overflow:hidden;position:relative;width:${w}px;height:${w}px;border-radius:50%;line-height:0;flex-shrink:0;">
  <img src="${src}" alt="" width="${w}" height="${w}" style="display:block;width:${w}px!important;height:${w}px!important;max-width:none!important;max-height:none!important;object-fit:contain;vertical-align:top;pointer-events:none;" />
  <span style="position:absolute;left:0;top:0;right:0;bottom:0;display:flex;align-items:center;justify-content:center;font-size:10px;font-weight:700;line-height:1;color:#fff;pointer-events:none;text-shadow:0 1px 2px rgba(0,0,0,0.4);">${d}</span>
</div>`
}
